function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardGeneric = function SvgCardGeneric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#8b9c8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.295.295 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.163.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .163.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#afbbb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.277 10.685a.5.5 0 0 0-.555 0l-2.597 1.731a.498.498 0 0 1-.277.084H28v1h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H28v1h8v-1h-.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.5v-1h-.849a.496.496 0 0 1-.277-.084l-2.597-1.731zM34 14a.5.5 0 0 0-.5-.5H33a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-3zm-3-.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.5z",
    style: {
      fill: "#e7ece9",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCardGeneric;